export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["number"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])}
}